


import { Component, Vue, Emit, Prop, Ref } from 'vue-property-decorator';

@Component({})
export default class BackgroundVideo extends Vue {
  @Ref('video') videoEl!: HTMLVideoElement;

  @Prop({}) url!: string;

  private isReady = false;

  @Emit()
  private ready() {
    this.isReady = true;

    return;
  }

  @Emit()
  private play() {
    this.ready();

    return;
  }

  @Emit()
  private end() {
    return;
  }

  @Emit()
  private error(error: MediaError) {
    return error;
  }

  public mounted() {
    this.videoEl.play().catch(error => {
      console.error('[BackgroundVideo]', error);
      this.end();
    });
  }
}
